import { z } from 'zod';
import { DEAL_TYPES, OFFICES } from '../enums.js';
/**
 * Per-user achievements over a date range.
 *
 * "Achievement" is split deliberately into effort and outcome. Counting only
 * closed deals would punish the groundwork that precedes them - the calls,
 * visits and quotes - so activity is reported beside outcomes rather than
 * being replaced by them.
 */
export const reportRangeSchema = z
    .object({
    from: z.string().date(),
    to: z.string().date(),
    userId: z.string().uuid().optional(),
})
    .refine((v) => v.from <= v.to, {
    message: 'The start date must be on or before the end date',
    path: ['from'],
});
// ------------------------------------------------------------- queries
/** Ageing is always "as of" a day; it defaults to today, resolved server-side. */
export const asOfSchema = z.object({
    asOf: z.string().date().optional(),
});
/**
 * A statement is always for one client over one range. Kept separate from
 * reportRangeSchema rather than extending it, so /reports/achievements cannot
 * silently start accepting a companyId.
 */
export const statementQuerySchema = z
    .object({
    companyId: z.string().uuid(),
    from: z.string().date(),
    to: z.string().date(),
})
    .refine((v) => v.from <= v.to, {
    message: 'The start date must be on or before the end date',
    path: ['from'],
});
/**
 * A plain date range. Deliberately not reportRangeSchema, which carries an
 * optional userId that the profit report would silently accept and ignore.
 */
export const profitRangeSchema = z
    .object({
    from: z.string().date(),
    to: z.string().date(),
})
    .refine((v) => v.from <= v.to, {
    message: 'The start date must be on or before the end date',
    path: ['from'],
});
/** The filters both deal reports share. All optional: the default is everything. */
const dealScopeQuery = {
    office: z.enum(OFFICES).optional(),
    ownerId: z.string().uuid().optional(),
    type: z.enum(DEAL_TYPES).optional(),
};
/** No dates: a forecast is the pipeline as it stands today. */
export const forecastQuerySchema = z.object(dealScopeQuery);
export const winLossQuerySchema = z
    .object({
    from: z.string().date(),
    to: z.string().date(),
    ...dealScopeQuery,
})
    .refine((v) => v.from <= v.to, {
    message: 'The start date must be on or before the end date',
    path: ['from'],
});
//# sourceMappingURL=report.js.map